import { LAxios } from "../axios";
import { catchHandler } from "../catch-handler";
import { GetUsersByDateOutput } from "./type";

export const getUsersByDate = async (data?: {
  startDate: string;
}): Promise<GetUsersByDateOutput[] | string | undefined> => {
  try {
    const response = await LAxios.get(
      "statistics/get-users-by-date/" + data?.startDate,
    );
    return response.data;
  } catch (error) {
    return catchHandler<GetUsersByDateOutput[] | string | undefined>(
      error,
      data,
      getUsersByDate,
      {},
    );
  }
};
